/* ForgotPassword.js */

import React, { useCallback, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Col, Row, Container, Card, CardBody, Form, FormGroup } from 'reactstrap';
import { useForm } from 'react-hook-form';

import { toast } from 'react-toastify';
import Strings from '../../translations/Translations';
import WAM from '../../services/WAM';
import Button1 from '../../components/buttons/Button1';

export default function ForgotPassword() {
  const history = useHistory();
  const { register, errors, handleSubmit, reset } = useForm();
  const [loading, setLoading] = useState(false);

  const onSubmit = useCallback(async ({ username }) => {
    setLoading(true);
    
    try {
      const response = await WAM.forgot({ un: username });

      setLoading(false);

      if (response.result === 'success') {
        toast.success(Strings('a_new_password_has_been_send_to_your_email'));
        reset();
        history.replace('/login');
      } else {
        const message = (response && response.error) ? response.error : Strings('error_on_forgot_password_request');
        toast.error(message);
      }
    } catch (err) {
      setLoading(false);
      toast.error(Strings('general_error'));
    }
  }, [setLoading, reset, history]);

  return (
    <div className='pb-bg-1'>
      <Container>
        <Row className='login-page justify-content-center align-items-center'>
          <Col md={6}>
            <Card className='p-2 shadow'>
              <CardBody>
                <div className='mb-4'>
                  <h1 className="h2 modal-title">{Strings('application_title')}</h1>
                </div>
                
                <div className='mb-2 mb-0'>
                  <h6 className="opacity-8">{Strings('forgot_your_password')}</h6>
                </div>

                <Form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
                  <Row>
                    <Col md={12}>
                      <FormGroup>
                        <input
                          type='text'
                          name='username'
                          placeholder={Strings('username_email')}
                          {...register('username', { required: true })}
                          className='form-control pb-input-1'
                        />
                        {errors && errors.username && errors.username.type === 'required' && (
                          <p role='alert' className='text-danger txt-small-1'>{Strings('username_is_required')}</p>
                        )}
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <div className="mt-2 mb-2 d-flex justify-content-between">
                      <Link className="pb-link-1" to="/login">
                        {Strings('return_to_login')}
                      </Link>
                    </div>

                    <div className='d-flex justify-content-center'>
                      <Button1 className='pb-btn-1' type='submit' size="lg" onClick={handleSubmit(onSubmit)} loading={loading}>
                        {Strings('recover_password')}
                      </Button1>
                    </div>
                  </Row>
                </Form>

                <div className="text-center opacity-8 mt-3">
                  Copyright &copy; Photozig Inc.
                </div>
              </CardBody>
              
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
